export default {
  IMPROVE: 'improve',
  REPHRASE: 'rephrase',
  FIX_GRAMMAR: 'fix_grammar',
  MAKE_LONGER: 'make_longer',
  MAKE_SHORTER: 'make_shorter',
  TRANSLATE: 'translate',
  CHANGE_TONE: 'change_tone',
  CUSTOM: 'custom',
};

export const textAssistantInstructionSuggestions = {
  WRITE_ABOUT: 'write-about',
  ADD_THAT: 'add-that',
  TRANSLATE_TO: 'translate-to',
  MENTION_THAT: 'mention-that',
  CHANGE_TONE_TO: 'change-tone-to',
};

export const textAssistantInstructionTones = {
  PROFESSIONAL: 'professional',
  CASUAL: 'casual',
  STRAIGHTFORWARD: 'straightforward',
  CONFIDENT: 'confident',
  FRIENDLY: 'friendly',
};

export const textAssistantInstructionTranslationLanguages = {
  EN_US: 'english-us',
  EN_UK: 'english-uk',
  DE: 'german',
  IT: 'italian',
  FR: 'french',
  ES: 'spanish',
  CS: 'czech',
  PT_BR: 'portuguese',
  SK: 'slovak',
  UA: 'ukrainian',
  HU: 'hungarian',
  PL: 'polish',
  FI: 'finnish',
  SV: 'swedish',
};

export const textAssistantInstructionTypes = {
  USER_INPUT: 'user-input',
  USER_INPUT_WITH_SUGGESTION: 'user-input-with-suggestion',
  PREDEFINED_PROMPT: 'predefined-prompt',
};
